import { Checkbox, Css, useComputed } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { AddProductOfferingConfig_ReadyPlanOptionsFragment } from "src/routes/libraries/product-offering-configs/AddProductOfferingConfigPage.generated";
import { ProductOfferingConfigForm } from "../AddProductOfferingConfigPage";
import { GroupedOptionsProps } from "./OptionsByOptionGroupSection";

type OptionSelectProps = Omit<GroupedOptionsProps, "groupedRpos"> & {
  rpo: AddProductOfferingConfig_ReadyPlanOptionsFragment;
  disabled: boolean;
  formState: ObjectState<ProductOfferingConfigForm>;
};

export function OptionSelect(props: OptionSelectProps) {
  const { disabled, rpo, formState, recomputeCosts } = props;
  const {
    optionGroup: { isMultiOptionGroup },
  } = rpo;
  const selected = useComputed(() => {
    return formState.value.readyPlanOptions?.some((os) => os.readyPlanOptionId === rpo.id) ?? false;
  }, [formState, rpo]);
  return (
    // Extra padding for checkbox field keeps the text alignment the same as the radio group field
    <div css={Css.if(!isMultiOptionGroup).ptPx(2).$}>
      {isMultiOptionGroup ? (
        // Do not use Beam's RadioGroupField here because it's not compatible with the pattern this page uses
        // TODO: Ideally we should re-write this page to use RadioGroupField having all RPOs as options
        <input
          type="radio"
          name={`optionGroup-${rpo.optionGroup.id}`}
          value={rpo.id}
          checked={selected}
          disabled={disabled}
          data-testid="radioInput"
          onChange={async (e) => {
            if (e.target.checked) {
              await recomputeCosts(rpo, true);
            }
          }}
          // Copied styles from Beam's RadioGroupField for consistency
          css={{
            ...Css.add("appearance", "none").p0.dib.vam.add("userSelect", "none").fs0.h2.w2.br100.$,
            ...Css.bgWhite.bcGray300.ba.$,
            ...Css.blue700.$,
            ...Css.transition.$,
            ...Css.cursorPointer.$,
            ...(selected
              ? {
                  ...Css.add("backgroundColor", "currentColor").$,
                  ...Css.add("backgroundImage", `url("${whiteCircle}")`).$,
                  ...Css.add("borderColor", "currentColor").$,
                }
              : {}),
          }}
        />
      ) : (
        <Checkbox
          label={`rpoId-${rpo.id}`}
          checkboxOnly
          disabled={disabled}
          onChange={async (isSelected) => {
            await recomputeCosts(rpo, isSelected);
          }}
          data-testid={`checkboxInput`}
          selected={selected}
        />
      )}
    </div>
  );
}

const whiteCircle =
  "data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='8' cy='8' r='4'/%3e%3c/svg%3e";
